import { Paper } from "@mui/material";
import { Link } from "react-router-dom";
import { Utils } from "@finpay-development/shared-platform/lib/esm/shared/utils";
import { StatusColors } from "@finpay-development/shared-platform/lib/esm/shared/enums";
import "./ioc-tile.scss";

export interface IocTileProps {
  title: string;
  subtitle: string;
  statusText?: string;
  statusColor: StatusColors;
  admissionDate?: string;
  reminderDate?: string;
  pfrTimingRiskPayorRisk?: string;
  riskClassName?: string;
  /** Patient FinAdvisor route, e.g. `/patients/123`. */
  titleTo?: string;
  /** Preload + navigate (same flow as former whole-card click). */
  onTitleClick?: () => void;
}

function IocTile(props: IocTileProps) {
  const {
    title,
    subtitle,
    statusText,
    statusColor,
    admissionDate,
    reminderDate,
    pfrTimingRiskPayorRisk,
    riskClassName,
    titleTo,
    onTitleClick,
  } = props;

  return (
    <Paper
      className="patient-records-ioc-tile p-2"
      style={{ borderColor: statusColor }}
    >
      <h3 className="tile-title">
        {titleTo ? (
          <Link
            to={titleTo}
            className="tile-title-link"
            draggable={false}
            onDragStart={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
            onClick={(e) => {
              e.stopPropagation();
              if (onTitleClick) {
                e.preventDefault();
                onTitleClick();
              }
            }}
            onMouseDown={(e) => e.stopPropagation()}
          >
            {title}
          </Link>
        ) : (
          title
        )}
      </h3>
      <div className="tile-body">
        {statusText ? <p>{statusText}</p> : null}
        {admissionDate ? (
          <p>{`Admitted ${Utils.convertISODate(new Date(admissionDate), false)}`}</p>
        ) : null}
        {pfrTimingRiskPayorRisk ? <p>{pfrTimingRiskPayorRisk}</p> : null}
        {riskClassName ? <p>{riskClassName}</p> : null}
      </div>
      {reminderDate ? (
        <p className="tile-reminder">
          {`Reminder: ${Utils.convertISODate(new Date(reminderDate), true)}`}
        </p>
      ) : null}
      {subtitle && subtitle !== "None" ? (
        <p className="tile-footer">{subtitle}</p>
      ) : null}
    </Paper>
  );
}

export default IocTile;
